import { render, staticRenderFns } from "./customlayout.vue?vue&type=template&id=4d04fa52&"
import script from "./customlayout.vue?vue&type=script&lang=js&"
export * from "./customlayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports